import { render } from "./EditEducationCenter.vue?vue&type=template&id=094b4de6&scoped=true"
import script from "./EditEducationCenter.vue?vue&type=script&lang=js"
export * from "./EditEducationCenter.vue?vue&type=script&lang=js"

import "./EditEducationCenter.vue?vue&type=style&index=0&id=094b4de6&scoped=true&lang=css"
import "./EditEducationCenter.vue?vue&type=style&index=1&id=094b4de6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094b4de6"]])

export default __exports__